import { RollbackOutlined } from '@ant-design/icons';
import { Dropdown, Menu, message } from 'antd';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useRecoverProductCatalogItemMutation } from 'redux/services/julia/juliaApi';
import { useGetCatalogConfigQuery } from 'redux/services/rudyCadabby/rudyCadabbyApi';
import { useAppSelector } from 'redux/store';

export const RecoverRulesContextMenu: React.FC = ({ children }) => {
  const { id: customerId } = useParams();
  const { pathname } = useLocation();
  /* ******************** Hooks ******************** */
  const { selectedRules } = useAppSelector((state) => state.assignedRules);

  const { data: catalogConfiguration } = useGetCatalogConfigQuery({ customerId: customerId as string });

  const [recoverCatalogItem] = useRecoverProductCatalogItemMutation();

  const isBusinessInheritance = catalogConfiguration?.dataInheritanceLevel === 'Business' && pathname.includes('/division/');

  /* ******************** Functions / Variables ******************** */
  const handleRestoreRules = async (): Promise<void> => {
    if (!customerId) {
      message.error('No entity selected!');

      return;
    }

    for (const productId of selectedRules) {
      try {
        await recoverCatalogItem({ customerId, productId }).unwrap();
      } catch {
        message.error(`Business product catalog item ${productId} failed to be recovered!`);
      }
    }

    message.success(`Business product catalog item(s) were successfully recovered!`);
  };

  const menu = (
    <Menu disabledOverflow={true}>
      <Menu.Item key="1" icon={<RollbackOutlined />} onClick={handleRestoreRules} disabled={isBusinessInheritance}>
        Restore
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['contextMenu']}>
      <div className="site-dropdown-context-menu">{children}</div>
    </Dropdown>
  );
};
